var React = require('react');

function IconMerge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M395.2 196.5c0-73.1-59.7-132.6-133.1-132.6s-133.2 59.5-133.2 132.6c0 55.4 34.5 103 83.1 122.8V704c-50.1 19.8-82.9 67.3-82.9 122.7 0 73.1 59.7 132.6 133.1 132.6s133-59.5 133-132.6c0-55.4-32.9-102.9-83-122.7V320.9c48.6-21.4 83-68.9 83-124.4zm-75.5 630.2c0 31.7-25.8 57.5-57.6 57.5s-57.6-25.8-57.6-57.5 25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5zM262.1 254c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5zM810.6 704V289.8c0-76.2-65.3-138.2-141.8-138.2h-40.3V64.2L502.2 198.6c-3.7 3.9-3.6 10 .1 13.8L628.5 342v-90.3h39.6c21.6 0 42.3 17.1 42.3 38V704c-37.6 19.8-79.1 67.3-79.1 122.7 0 73.1 61.6 132.6 135 132.6s130.1-59.5 130.1-132.6c0-55.4-35.7-102.9-85.8-122.7zm-42.5 180.2c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z"}));
}

IconMerge.displayName = "IconMerge";

IconMerge.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconMerge;

IconMerge.default = IconMerge;
